import { useState } from 'react'

import s from './BurgerWrapper.module.scss'

import { useDeviceContext } from 'contexts/DeviceContext'

import { ListIcon } from 'assets/icons/ListIcon'
import { ArrowDownIcon } from 'assets/icons/ArrowDownIcon'

interface Props {
  children: React.ReactNode | React.ReactNode[]
  className?: string
  wrapperClassName?: string
  breakpoint?: number
}

export const BurgerWrapper = ({ children, breakpoint = 880, className, wrapperClassName }: Props) => {
  const { deviceWidth } = useDeviceContext()
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div className={`${s.wrapper} ${wrapperClassName}`}>
      {breakpoint >= deviceWidth ? (
        <button className={s.button} onClick={() => setIsOpen((prev) => !prev)}>
          <ListIcon className={s.icon} /> Filters <ArrowDownIcon className={s.icon}/>
        </button>
      ) : null}
      <div className={`${s.childrenWrapper} ${breakpoint >= deviceWidth ? (isOpen ? s.open : s.closed) : ''} ${className}`}>
        {children}
      </div>
    </div>
  )
}
